/* eslint-disable react/jsx-no-bind */
import * as React from 'react'
import styled from 'styled-components'

import { GENERAL_COLORS as COLORS } from '../../constants/colors'

const Input = styled.input`
  border-radius: 0;
  width: 40px;
  height: 60px;
  font-size: 36px;
  padding: 0;
  font-family: ${({ disabled }) => (disabled ? 'Regular' : 'Thin')};
  margin: 5px;
  background: none;
  text-align: center;
  border: none;
  color: ${p => (p.error ? '#D34F51' : p.theme.color.mainFont)};
  box-shadow: 0
    ${({ disabled, error, active }) =>
      disabled || error ? 3 : active ? 2 : 1}px
    0
    ${({ error, active }) =>
      error ? '#D34F51' : active ? '#32A6FE' : '#CDD8E5'};

  &::placeholder {
    color: ${COLORS.gray};
  }
  &:focus::placeholder {
    opacity: 0;
  }
`

const InputSegment = React.forwardRef(
  ({ value, disabled, focus, ...props }, ref) => (
    <Input
      type="text"
      maxLength={1}
      placeholder="0"
      autoComplete="false"
      empty={!value}
      active={!!value}
      value={disabled ? '-' : value}
      disabled={disabled}
      ref={ref}
      {...props}
    />
  )
)

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.inputs = []
  }
  setCodeAtPosition = (at, char) => {
    const {
      input: { onChange, value }
    } = this.props

    if (isNaN(+char)) {
      return
    }

    let newCodeSplitted = value.split('')
    newCodeSplitted = [
      ...newCodeSplitted,
      ...new Array(
        newCodeSplitted.length - 1 >= at ? 0 : at - newCodeSplitted.length + 1
      ).fill(' ')
    ]
    newCodeSplitted[at] = char
    newCodeSplitted.map(x => x || '')

    onChange(newCodeSplitted.join(''))
  }

  removeLastCodeChar = () => {
    const {
      input: { onChange, value }
    } = this.props

    const newCodeSplitted = value.split('').slice(0, -1)
    onChange(newCodeSplitted.join(''))
  }
  pasteHandler = e => {
    const {
      input: { onChange },
      count
    } = this.props
    const pasted = e.clipboardData.getData('Text')
    if (pasted.length === count) {
      onChange(pasted)
    }
  }
  render() {
    const { input, count, isError } = this.props

    const { value } = input

    const segmentValues = value.split('')

    const segmentValuesFilled = [
      ...segmentValues,
      ...new Array(count - segmentValues.length).fill('')
    ]

    let focusOn = segmentValuesFilled.findIndex(x => x === '')
    if (value.length >= count) {
      focusOn = count - 1
    }
    return (
      <Wrapper>
        <input type="hidden" {...input} />
        {segmentValuesFilled.map((i, idx) => (
          <InputSegment
            onPaste={this.pasteHandler}
            error={isError}
            value={i}
            key={idx}
            focus={focusOn === idx}
            ref={el => {
              if (focusOn === idx && el) el.focus()
              this.inputs[idx] = el
            }}
            onKeyUp={e =>
              e.key === 'Backspace' ? this.removeLastCodeChar(idx - 1) : null
            }
            onKeyDown={e => (e.key === 'Backspace' ? e.preventDefault() : null)}
            onChange={e => this.setCodeAtPosition(idx, e.target.value)}
            onFocus={_ =>
              focusOn !== idx && this.inputs[focusOn]
                ? this.inputs[focusOn].focus()
                : null
            }
          />
        ))}
      </Wrapper>
    )
  }
}
